// SPEC-CHINA-COMPANY-OUTBOUND-PICKER-001 §4.5 (e) / REQ-OP-033 판단 34
// 서버 오류 메시지에서 코드 토큰(OP-AUTHZ-001, OP-PROV-001 등)을 추출하는 공용 헬퍼.
// OutboundCustomerPicker(패널 로드 실패)와 CompanyFormModal(저장 실패) 양쪽에서 재사용한다.

/**
 * @param {string} message - 서버 원문 오류 메시지 (예: "접근 권한이 없습니다. (OP-AUTHZ-001: ...)")
 * @returns {string|null} 매칭된 토큰(예: "OP-AUTHZ-001") 또는 null
 */
export function extractErrorCodeToken(message) {
  if (!message) return null;
  const m = String(message).match(/\((OP-[A-Z]+-\d+)/);
  return m ? m[1] : null;
}
